<template>
  <div role="listitem" :class="thoughtClass">
    <!-- AVATAR TOP ROW -->
    <div class="col-12">
      <avatar
        :showSocialSharing="canShowSocialSharing && socialSharingNextToEditButton"
        :user="thought.owner ? thought.owner : {}"
        :anon="thoughtIsAnonym(thought)"
        :context_obj="thought"
        :enable_edit="!config.disableEditing && canEditThought(thought)"
        :topic="topic"
        @edit="emitEditThought(thought.id, thought.topic.id)"
      />
    </div>

    <!-- CONTENT MIDDLE ROW -->
    <div class="col-12">
      <div class="row d-flex align-items-center">
        <!-- Themenbereich -->
        <div
          v-if="project.config && toBool(project.config.show_thought_themenbereich_icon) && themeCode"
          class="col-2 d-none d-md-flex flex-wrap align-items-center justify-content-center"
        >
          <div v-for="(value, index) in themeCode.value_all" v-bind:key="value" class="p-1">
            <img
              :src="themeUrl + `/${value}.png`"
              :title="themeCode.value_human_all[index]"
              class="img-fluid icon-clickable"
              style="width: 35px; height: 35px; min-width: 35px"
              :alt="'Theme' + themeCode.value_human_all[index]"
              @click="setFilterFromThought('attribute' + themeCode.id, value)"
            />
          </div>
        </div>
        <!-- Main Content -->
        <div :class="mainColumn">
          <!-- <div class="row">
            <div class="col-md-12">
              <avatar
                :user="thought.owner ? thought.owner : {}"
                :anon="thoughtIsAnonym(thought)"
                :context_obj="thought"
                :enable_edit="!config.disableEditing && canEditThought(thought)"
                :topic="topic"
                @edit="emitEditThought(thought.id, thought.topic.id)"
              />
            </div>
          </div> -->
          <div class="row widget-content">
            <div class="col-md-12">
              <thought-list-content
                v-if="topic"
                :thought="thought"
                :topic="topic"
                :config="config"
                @openThought="emitOpenThought(thought.id, thought.topic.id)"
              />
              <span>
                <thought-support-controls
                  v-if="canShowThoughtVoteButton && topic.votetype != 'stars'"
                  :topic="topic"
                  :thought="thought"
                  :signalRefresh="voteRefreshCount"
                  :fromList="true"
                  @support-requires-comment="onVoteRequiresComment"
                  @support-vote-sent="onVoteSuccess"
                />
                <span v-if="(canCommentOnThoughts(topic) || canCommentAfterLogin(topic)) && showCommentButton">
                  <button
                    v-if="!isHiddenThought"
                    :id="commentBtnId"
                    class="btn wdw-thought-btn wdw-thought-comment-button"
                    :class="commentBtnClasses"
                    :disabled="newComment"
                    :title="domainStore.translate('discuss.comment.create.button-title')"
                    v-tooltip.bottom="domainStore.translate('discuss.comment.create.button-title')"
                    @click="clickNewCommentButton"
                  >
                    <font-awesome-icon :icon="['far', 'comment']" aria-hidden="true" />
                    <span class="visually-hidden">
                      {{ domainStore.translate('discuss.comment.create.button-title') }}
                    </span>
                  </button>
                </span>
                <OverlayPanel
                  v-if="!isLoggedIn"
                  ref="loginOP"
                  :showCloseIcon="true"
                  :dismissable="true"
                  appendTo="body"
                  class="wdw-widgets"
                >
                  <p>{{ domainStore.translate('discuss.comment.message.requires-login') }}</p>
                  <Login :domainid="domainid" />
                </OverlayPanel>
                <span v-if="topic !== null && topic.allow_support" class="create-button">
                  <button
                    v-if="!isHiddenThought"
                    class="btn wdw-thought-btn"
                    :class="commentBtnClasses"
                    :onclick="participateInThought"
                    :title="domainStore.translate('discuss.thought.participate-button-title')"
                    v-tooltip.bottom="domainStore.translate('discuss.thought.participate-button-title')"
                  >
                    <font-awesome-icon :icon="['fas', 'user-plus']" aria-hidden="true" />
                    <span class="visually-hidden">
                      {{ domainStore.translate('discuss.thought.participate-button-title') }}
                    </span>
                  </button>
                </span>
                <span v-if="topic !== null && (canFeedbackOnThoughts(topic) || canFeedbackAfterLogin(topic))">
                  <button
                    v-if="!isHiddenThought"
                    class="btn wdw-thought-btn wdw-thought-feedback-button"
                    :class="feedbackBtnClasses"
                    :disabled="newFeedback"
                    v-tooltip.bottom="
                      feedbackState.response
                        ? domainStore.translate('discuss.feedback.button.edit')
                        : domainStore.translate('discuss.feedback.button.create')
                    "
                    @click="clickFeedbackButton"
                  >
                    <font-awesome-icon :icon="['fas', 'circle-arrow-right']" aria-hidden="true" />
                    <span class="visually-hidden">{{ domainStore.translate('discuss.feedback.title') }}</span>
                  </button>
                  <OverlayPanel
                    v-if="!isLoggedIn"
                    ref="loginFeedbackOP"
                    :showCloseIcon="true"
                    :dismissable="true"
                    appendTo="body"
                    class="wdw-widgets"
                  >
                    <p>{{ domainStore.translate('discuss.feedback.message.requires-login') }}</p>
                    <Login :domainid="domainid" />
                  </OverlayPanel>
                </span>
              </span>
              <VoteWeight :topic="topic" :thought="thought" />
            </div>

            <div v-if="topic.votetype == 'stars'">
              <div class="d-flex flex-row flex-wrap">
                <div v-if="canShowThoughtVoteButton">
                  <thought-support-controls
                    :topic="topic"
                    :thought="thought"
                    :signalRefresh="voteRefreshCount"
                    :fromList="true"
                    @support-requires-comment="onVoteRequiresComment"
                    @support-vote-sent="onVoteSuccess"
                  />
                </div>
                <div v-if="canShowVoteStats && !config.hideVoting" :class="topic.new_votes ? 'mx-3' : ''">
                  <vote-stats :topic="topic" :voteInfo="voteInfo" />
                </div>
              </div>
            </div>

            <div
              v-if="
                (canShowVoteStats && !config.hideVoting && topic.votetype != 'stars') ||
                showCommentCount ||
                showFeedbackCount
              "
              class="col-md-12 icon-container"
            >
              <div class="mt-1 mb-2 small" v-if="canShowVoteStats && !config.hideVoting && topic.votetype != 'stars'">
                <vote-stats :topic="topic" :voteInfo="voteInfo" />
              </div>

              <span class="comment-count" v-if="showCommentCount">
                <font-awesome-icon :icon="['far', 'comment']" />
                {{ thought.commentcount }}
                <span class="visually-hidden">{{ domainStore.translate('discuss.comment.title') }}</span>
              </span>

              <span
                v-if="showFeedbackCount"
                class="feedback-count"
                v-tooltip.bottom="feedbackResponseCountText"
                @click="openFeedbackStats"
              >
                <font-awesome-icon :icon="['fas', 'circle-arrow-right']" aria-hidden="true" />
                {{ thought.feedback_response_stats.responsecount }}
              </span>
              <span v-if="showFeedbackCount" class="visually-hidden">{{ feedbackResponseCountText }}</span>
            </div>
            <div v-if="newFeedback">
              <feedback-response :thought="thought" :topic="topic" @feedback-form-close="onFeedbackFormClosed" />
            </div>
            <div v-if="!config.hideComments" ref="commentListContainer" class="thought-listitem-comment">
              <comment-list
                :topic="topic"
                :loadAll="false"
                :thought="thought"
                :signalRefresh="refreshCount"
                :showNewComment="newComment"
                :newCommentText="newCommentText"
                :newCommentVote="newCommentVote"
                :initCommentsFromThought="true"
                @comment-form-close="onCommentFormClosed"
                @comment-updated="onMyCommentUpdated"
                @comment-vote-sent="onVoteWithCommentSent"
              />
            </div>
          </div>
        </div>
        <!-- Beteiligungsstufen -->
        <div v-if="stufeCode && toBool(project.config.show_thought_stufe_icon)" class="col-2">
          <div v-for="(value, index) in stufeCode.value_all" v-bind:key="value">
            <img
              class="img-fluid icon-clickable stufe-icon"
              :title="stufeCode.value_human_all[index]"
              :src="stufeUrl + `/${value}.png`"
              :alt="'stufe' + stufeCode.value_human_all[index]"
              @click="setFilterFromThought('attribute' + stufeCode.id, value)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- SOCIAL-SHARING BOTTOM ROW -->
    <div class="col-12" v-if="canShowSocialSharing && !socialSharingNextToEditButton">
      <div class="col-md-12 mb-2 mt-2">
        <wdw-social-sharing
          :url="getCurrenThoughtUri(thought.id)"
          :title="thought.title"
          :description="truncate(thought.content)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { userStore } from '@/store/user-store';
import { projectStore } from '@/store/project-store';
import useHashParams from '@/composables/general/useHashParams';
import { useRoute } from 'vue-router';
import { toRefs, ref, watch, computed, onMounted, nextTick } from 'vue';
import { domainStore } from '@/store/domain-store';
import useConverter from '@/composables/general/useConverter';
import thoughtRepository from '@/api/thoughtRepository';
import Avatar from '@/components/discuss/general/Avatar.vue';
import ThoughtListContent from '@/components/discuss/thought/ListContent.vue';
import FeedbackResponse from '@/components/discuss/feedback/FeedbackResponse.vue';
import WdwSocialSharing from '@/components/general/WdwSocialSharing.vue';
import ThoughtSupportControls from '@/components/discuss/thought/SupportControls.vue';
import CommentList from '@/components/discuss/comment/CommentList.vue';
import ThoughtEventMixins from '@/mixins/ThoughtEventMixins';
import useThoughtEvents from '@/composables/thought/useThoughtEvents';
import useThoughtConfig from '@/composables/thought/useThoughtConfig';
import useThoughtHelpers from '@/composables/thought/useThoughtHelpers';
import useStringManip from '@/composables/general/useStringManip';
import useTopicConfig from '@/composables/topic/useTopicConfig';
import OverlayPanel from 'primevue/overlaypanel';
import Login from '@/components/user/Login.vue';
import VoteStats from '@/components/discuss/thought/VoteStats.vue';
import VoteWeight from '@/components/discuss/thought/VoteWeight.vue';
import useThoughtFeedbackState from '@/composables/thought/useThoughtFeedbackState';
import { filterStore } from '@/store/filter-store';
import useLocalCache from '@/composables/general/useLocalCache';

// TODO -> fully implement
export default {
  name: 'ThoughtListWrapper',
  mixins: [ThoughtEventMixins],
  props: {
    thought: {
      type: Object,
      required: true,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    socialSharingNextToEditButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    //--------------------------------------VARS---------------------------------------
    const route = useRoute();
    const { storeRedirUrlInCache } = useLocalCache();
    const { setHashParams } = useHashParams(route);
    const { thought, config } = toRefs(props);
    const { emitOpenThought, emitEditThought } = useThoughtEvents(context);
    const { canCommentOnThoughts, canCommentAfterLogin, canFeedbackOnThoughts, canFeedbackAfterLogin } =
      useTopicConfig();
    const { canEditThought, canShowSocialShare, thoughtIsAnonym } = useThoughtConfig();
    const { feedbackState } = useThoughtFeedbackState(thought.value.id);
    const refreshCount = ref(0);
    const voteInfo = ref(null);
    const voteRefreshCount = ref(0);
    const newComment = ref(false);
    const newCommentText = ref('');
    const newCommentVote = ref(0);
    const newFeedback = ref(false);
    const loginOP = ref();
    const loginFeedbackOP = ref();
    const { getCurrenThoughtUri } = useThoughtHelpers();
    const { truncate } = useStringManip();
    const { toBool } = useConverter();
    const commentListContainer = ref(HTMLElement | null);

    // computed
    const thoughtClass = computed(() => {
      return {
        ['thought-' + thought.value.id]: true,
        'thought-box-linked': config.value.linkThoughtBox,
        row: true,
        'd-flex': true,
        'align-content-center': true,
        'align-items-center': true,
        'in-list': true,
        'thought-wrapper': true,
        'position-relative': true,
      };
    });
    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const domain = computed(() => {
      return domainStore.getState().domain;
    });
    const canShowSocialSharing = computed(() => {
      return domain.value ? domain.value.enable_social_sharing : false;
    });
    const topic = computed(() => {
      return projectStore.getFetchedTopic(props.thought.topic.id);
    });
    const project = computed(() => {
      return projectStore.getState().project;
    });
    const stufeUrl = computed(() => {
      return project.value.config.thought_stufe_icon_url;
    });
    const themeUrl = computed(() => {
      return project.value.config.thought_themenbereich_icon_url;
    });
    const projectStufeAtrribute = computed(() => {
      if (project.value.config && project.value.config.stufe_attribute) {
        return project.value.config.stufe_attribute;
      }
      return '';
    });
    const projectThemeAtrribute = computed(() => {
      if (project.value.config && project.value.config.themenbereich_attribute) {
        return project.value.config.themenbereich_attribute;
      }
      return '';
    });
    const stufeCode = computed(() => {
      return props.thought.attributes.find(element => {
        return element.code == projectStufeAtrribute.value;
      });
    });
    const themeCode = computed(() => {
      return props.thought.attributes.find(element => {
        return element.code == projectThemeAtrribute.value;
      });
    });
    const projectHasThemenbereichConfig = computed(() => {
      if (project.value.config && project.value.config.show_thought_themenbereich_icon) {
        return true;
      }
      return false;
    });
    const projectHasStufeConfig = computed(() => {
      if (project.value.config && project.value.config.show_thought_stufe_icon) {
        return true;
      }
      return false;
    });
    const mainColumn = computed(() => {
      if (!stufeCode.value || !projectHasStufeConfig.value || !projectHasThemenbereichConfig.value) {
        if (!stufeCode.value && !projectHasThemenbereichConfig.value) {
          return 'col-12';
        }
        return 'col-10';
      } else {
        return 'col-8';
      }
    });
    const commentBtnId = computed(() => {
      return 'thought-' + thought.id + '-comment-btn';
    });
    const commentBtnClasses = computed(() => {
      return {
        disabled: newComment.value,
      };
    });
    const feedbackBtnClasses = computed(() => {
      return {
        disabled: newFeedback.value,
        feedback_received: feedbackState.response ? true : false,
      };
    });
    const isHiddenThought = computed(() => {
      if (thought.value && thought.value.status) {
        return thought.value.status == 'hide';
      }
      return false;
    });
    const canShowThoughtVoteButton = computed(() => {
      if (topic.value && topic.value.allow_voting_per_thought == 1) {
        return thought.value.allow_voting == 1 && !isHiddenThought.value;
      }
      return true;
    });
    const canShowVoteStats = computed(() => {
      return (
        voteInfo.value !== null && // Vote statistic exists
        topic.value != null && // Topic exists
        !isHiddenThought.value && // Thought is visible
        (topic.value.displayvotes === 'always' || // Always display the vote
          (topic.value.votetype !== 'none' && !topic.value.new_votes && topic.value.displayvotes == 'aftervote')) // Can only display after vote is closed
      );
    });

    const showCommentCount = computed(() => {
      return thought.value.commentcount > 0 && !config.value.hideCommentButton && config.value.hideComments;
    });
    const showCommentButton = computed(() => {
      if (config.value.hideCommentButton) {
        return false;
      }
      if (config.value.hideVoting && !config.value.hideCommentButton && config.value.hideComments) {
        return topic.value.commented_voting == 'force' ? false : true;
      }
      return true;
    });
    const showFeedbackCount = computed(() => {
      return (
        thought.value.feedback_response_stats &&
        thought.value.feedback_response_stats.responsecount > 0 &&
        topic.value.feedback != null && // Feedback exists
        (topic.value.feedback.displayfeedback === 'always' || // Always display the feedback
          (!topic.value.feedback.active && topic.value.feedback.displayfeedback == 'afterfeedback')) // Can only display after feedback is closed
      );
    });
    const feedbackResponseCountText = computed(() => {
      return domainStore.translate('discuss.feedback.message.response-count', {
        count: thought.value.feedback_response_stats?.responsecount,
      });
    });

    //functions

    function assignVoteInfoFromThought() {
      voteInfo.value = {
        id: thought.value.id,
        links: thought.value.links,
        vote_nnp_con: thought.value.vote_nnp_con,
        vote_nnp_pro: thought.value.vote_nnp_pro,
        votecount: thought.value.votecount,
        votesum: thought.value.votesum,
      };
    }

    function fetchThoughtVoteInfo() {
      thoughtRepository
        .getVoteInfo(thought.value.id)
        .then(t => {
          voteInfo.value = t;
        })
        .catch(e => {
          voteInfo.value = null;
        });
    }
    function onVoteWithCommentSent(vote) {
      voteRefreshCount.value += 1;
      fetchThoughtVoteInfo();
    }
    function onVoteSuccess(vote) {
      fetchThoughtVoteInfo();
    }
    //comments Section
    function showNewComment(val = true) {
      newComment.value = val;
    }
    function clickNewCommentButton(event) {
      // to prevent error in customer-systems T14938
      event.stopPropagation();
      event.preventDefault();

      //Check if user is logged in
      if (canCommentOnThoughts(topic.value)) {
        if (config.value.hideComments) {
          event.stopPropagation();
          emitOpenThought(thought.value.id, thought.value.topic.id, { openCommentForm: true });
        } else {
          showNewComment(true);
        }
        //Show create form when user is logged in
      } else if (canCommentAfterLogin(topic.value)) {
        loginOP.value.show(event);
        storeRedirUrlInCache('comment-thought', { thoughtid: thought.value.id });
      } else {
        console.error('error: cannot create comment, but button visible/clicked');
      }
    }
    function onVoteRequiresComment(param) {
      // When voting requires comment to be sent

      if (param.commented_voting == 'optional') {
        newCommentText.value = domainStore.translate('discuss.thought.message.vote-optional-comment');
      } else if (param.commented_voting == 'force') {
        newCommentText.value = domainStore.translate('discuss.thought.message.vote-requires-comment');
      } else {
        newCommentText.value = '';
      }
      newCommentVote.value = param.voteValue;
      if (config.value.hideComments) {
        emitOpenThought(thought.value.id, thought.value.topic.id, {
          openCommentForm: true,
          commentHint: newCommentText.value,
          voteValue: newCommentVote.value,
        });
      } else {
        showNewComment(true);
      }
    }
    function onCommentFormClosed() {
      // comment form closed
      showNewComment(false);
      newCommentText.value = '';
      newCommentVote.value = 0;
    }
    function onMyCommentUpdated() {
      // added new comment or existing comment is updated
      showNewComment(false);
      newCommentText.value = '';
      newCommentVote.value = 0;
    }
    function participateInThought(e) {
      e.stopPropagation();
      e.preventDefault();
      thoughtRepository.getSupportEmailContet(thought.value.id).then(data => {
        const supportEmailContent = data.support_email_content;
        window.location.href = `mailto:${topic.value.support_email}?subject=${encodeURIComponent(
          supportEmailContent.subject
        )}&body=${encodeURIComponent(supportEmailContent.body)}`;
      });
    }

    function showNewFeedback(val = true) {
      newFeedback.value = val;
    }
    function onFeedbackFormClosed(data) {
      feedbackState.response = data.response;
      // feedback form closed
      showNewFeedback(false);
    }
    function clickFeedbackButton(event) {
      // to prevent error in customer-systems T14938
      event.stopPropagation();
      event.preventDefault();

      //Check if user is logged in
      if (canFeedbackOnThoughts(topic.value)) {
        if (config.value.hideFeedback) {
          event.stopPropagation();
          emitOpenThought(thought.value.id, thought.value.topic.id, { openFeedbackForm: true });
        } else {
          showNewFeedback(true);
        }
      } else if (canFeedbackAfterLogin(topic.value)) {
        loginFeedbackOP.value.show(event);
      } else {
        console.error('error: cannot create feedback_response, but button visible/clicked');
      }
    }

    function openFeedbackStats(event) {
      // to prevent error in customer-systems T14938
      event.stopPropagation();
      event.preventDefault();

      emitOpenThought(thought.value.id, thought.value.topic.id, { openFeedbackStats: true });
    }

    // Sets key-value that is passed as filter to the filter form
    // Note: This is done through change in hash parameters
    function setFilterFromThought(key, value) {
      filterStore.setIndividualFilter({ key: key, value: value }, route, true);
    }

    watch(props.thought, (newT, oldT) => {
      assignVoteInfoFromThought();
    });

    onMounted(() => {
      assignVoteInfoFromThought();
      if (
        config.value.hideComments &&
        config.value.hideVoting &&
        !config.value.hideCommentButton &&
        topic.value.commented_voting == 'force'
      ) {
        console.warn('Buttons hidden because config settings in ListWrapper');
      }
    });
    return {
      domainStore,
      //----------------VARS------------------
      voteRefreshCount,
      refreshCount,
      newComment,
      newCommentText,
      newCommentVote,
      voteInfo,
      loginOP,
      loginFeedbackOP,
      newFeedback,
      feedbackState,
      // Computed
      commentBtnId,
      thoughtClass,
      canShowSocialSharing,
      isLoggedIn,
      user,
      topic,
      project,
      stufeUrl,
      themeUrl,
      projectStufeAtrribute,
      stufeCode,
      themeCode,
      mainColumn,
      commentBtnClasses,
      feedbackBtnClasses,
      isHiddenThought,
      canShowThoughtVoteButton,
      canShowVoteStats,
      commentListContainer,
      domainid,
      showCommentCount,
      showFeedbackCount,
      showCommentButton,
      feedbackResponseCountText,
      // Methods
      emitOpenThought,
      thoughtIsAnonym,
      emitEditThought,
      canShowSocialShare,
      canEditThought,
      onVoteWithCommentSent,
      onVoteSuccess,
      clickNewCommentButton,
      onVoteRequiresComment,
      onCommentFormClosed,
      canCommentOnThoughts,
      canCommentAfterLogin,
      canFeedbackOnThoughts,
      canFeedbackAfterLogin,
      onMyCommentUpdated,
      getCurrenThoughtUri,
      truncate,
      participateInThought,
      onFeedbackFormClosed,
      clickFeedbackButton,
      openFeedbackStats,
      setFilterFromThought,
      toBool,
    };
  },

  components: {
    Avatar,
    ThoughtListContent,
    ThoughtSupportControls,
    CommentList,
    WdwSocialSharing,
    OverlayPanel,
    VoteStats,
    VoteWeight,
    Login,
    FeedbackResponse,
  },
};
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
.mt-1 {
  display: inline-block;
}
.in-list.thought-wrapper {
  border-bottom: 2px solid #424242;
  margin: 20px 0px;
}
.thought-box-linked:hover {
  background-color: #eee;
  cursor: pointer;
}
.comment-count,
.feedback-count {
  margin-right: 0.8em;
  cursor: pointer;
}
.icon-clickable {
  cursor: pointer;
}
.thought-listitem-comment {
  margin-bottom: 20px;
}
.icon-container {
  margin-bottom: 10px;
}
.stufe-icon {
  margin: 2px;
  min-width: 30px;
  width: 50px;
}
</style>
